export enum LocaleEnum {
  English = 'en',
  French = 'fr',
}
